import { createActionTypeModel } from "../../../../store/global/action-model";


export const GET_BOOKING_REPORTS_ARTIST_REPORT = 'GET_BOOKING_REPORTS_ARTIST_REPORT';
export const SET_BOOKING_REPORTS_ARTIST_REPORT = 'SET_BOOKING_REPORTS_ARTIST_REPORT';